import React from 'react';

import { Tooltip, TooltipProps } from '@mantine/core';

import classes from './kiloTooltip.module.css';

type WrapperDivClassVariantType = 'default' | 'defaultAbsolute'; // Add more as needed

interface KiloTooltipProps extends Partial<TooltipProps> {
  label: string;
  children: React.ReactNode;
  position?: TooltipProps['position'];
  wrapperDivClassVariantType?: WrapperDivClassVariantType;
}

const wrapperClassMap: Record<WrapperDivClassVariantType, string> = {
  default: '',
  defaultAbsolute: classes.defaultAbsolute,
};

const KiloTooltip = ({
  label,
  children,
  position = 'top',
  wrapperDivClassVariantType = 'default',
  ...rest
}: KiloTooltipProps): JSX.Element => {
  const wrapperClassName = wrapperClassMap[wrapperDivClassVariantType];
  return (
    <Tooltip arrowSize={6} label={label} withArrow position={position} classNames={classes} {...rest}>
      <div className={wrapperClassName}>{children}</div>
    </Tooltip>
  );
};

export default KiloTooltip;
